import {Brick, Config, Predicate, Query, registerBrick, WorkflowObjectState} from 'olympe';
import {getLogger} from '@olympeio/core';
import BCP from './DM_BCP.js';
import {BCP_WORKFLOW_STATES} from './BcpWorkflowAuthorizations';

// noinspection JSUnusedGlobalSymbols
export default class EmailAction extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     * @param {function(string)} setBcp
     */
    update($, inputs, [forwardEvent, setBcp]) {
        // Write your code here. You have to implement this method !
        // Executed every time the brick receives a new trigger event, override `setupExecution()` to change the behavior.

        // this combines the BCP request with same user id
        const mergeDuplicate = (mod) => {
            let result = [];
            mod.forEach(elem => {
                let match = result.find(r => r.To === elem.To);
                if (match) {
                    match.content.push(...elem.content);
                } else {
                    result.push(elem);
                }
            });
            subjectGen(result);


        };

        // this will generate action detail content for email notification

        const subjectGen = (data) => {
            data.forEach(x => {
                if (x.content.length >= 1) {
                    x.emailCont = [{BP: []}, {PM: []}];
                    for (let i = 0; i < x.content.length; i++) {
                        if (x.content[i].workflowState === BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM) {
                            x.emailCont[1].PM.push(`<li>plant: ${x.content[i].plant}&#44; material: ${removeZeros(x.content[i].material)} & requestor: ${x.content[i].requestor}</li>`);
                        } else if (x.content[i].workflowState === BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP) {
                            x.emailCont[0].BP.push(`<li>plant: ${x.content[i].plant}&#44; material: ${removeZeros(x.content[i].material)} & requestor: ${x.content[i].requestor}</li>`);
                        }

                    }
                }
            });
            setBcp(data);
        };

        // get mail id from user names
        const getmailID = (str, opt) => {
            return str.split(';')[opt];
        };

        // remove leading 0's in numbers

        const removeZeros = (num) => {
            return num.replace(/^0+/, '');
        };

        // getting BCP data based on workflow state (Alternative VS suggestion by BP and Alternative VS check by PM)
        const logger = getLogger('GetUserBCPs');
        /** @type {!Array<string>} */
        const blacklist = Config.getParameter('emailBlacklist') || [];
        let query = Query.instancesOf(BCP).andReturn()
            .follow(WorkflowObjectState.currentObjectRel.getInverse())
            .filter(
                Predicate.or(
                    Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP),
                    Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM)
                ))
            .andReturn();
        query.execute().then((queryResult) => {
            let Qr = queryResult.toArray();
            let mod = [];
            Qr.forEach(([bcp, workflowObject]) => {

                // checking notification props with current workflow state of the BCP request
                // if both are not equall ad null it generate the list of object which have to send a email notification


                if (bcp.get(BCP.notification_stageProp) !== workflowObject.get(WorkflowObjectState.stateProp) || bcp.get(BCP.notification_stageProp) === null) {

                    let plantID = bcp.get(BCP.plantIdProp);
                    let materialID = bcp.get(BCP.materialIdProp);
                    let workflowState = workflowObject.get(WorkflowObjectState.stateProp);
                    let bcpTag = bcp.getTag();
                    if (workflowObject.get(WorkflowObjectState.stateProp) === BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP) {
                        let tomail = getmailID(bcp.get(BCP.businessPartnerProp), 1);
                        if (!blacklist.includes(tomail?.toLowerCase())) {
                            mod.push({
                                To: tomail,
                                content: [{
                                    plant: plantID, material: materialID, workflowState: workflowState, tag: bcpTag, bcpRequest: bcp, requestor:getmailID(bcp.get(BCP.requestorProp),0)
                                }]
                            });
                        } else {
                            logger.info(`Email ${tomail} was ignored by the blacklist`);
                        }

                    } else if (workflowObject.get(WorkflowObjectState.stateProp) === BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM) {
                        let tomail = getmailID(bcp.get(BCP.procurementManagerProp), 1);
                        if (!blacklist.includes(tomail?.toLowerCase())) {
                            mod.push({
                                To: tomail,
                                content: [{
                                    plant: plantID, material: materialID, workflowState: workflowState, tag: bcpTag, bcpRequest: bcp, requestor:getmailID(bcp.get(BCP.requestorProp),0)
                                }]
                            });
                        } else {
                            logger.info(`Email ${tomail} was ignored by the blacklist`);
                        }
                    }

                }


            });

            mergeDuplicate(mod);


        })
            .catch(error => {
                logger.error(error);
                setBcp([]);
            }).finally(() => {
                forwardEvent();
            });
    }
}

registerBrick('0189f396afe0f0178730', EmailAction);
